import toFormat from "./toFormat";

export default function toMMDDYYYY(x: Date) {
  return toFormat(x, "MM/dd/yyyy");
}
